export default string => (string.length === 1 && string.includes('-') ? '' : string);
